import React, { Component } from 'react';

import Regua from '../../components/Regua/Regua';
import LegacyMode from '../../components/LegacyMode/LegacyMode';

class LayoutPublic extends Component {
  render() {
    return (
      <>
        <LegacyMode />
        <div>
          {this.props.children}
        </div>
        <Regua open={false} />
      </>
    );
  }
}

export default LayoutPublic;